import { Link, useNavigate } from "react-router-dom";
import { LayoutDashboard, Package, PlusCircle, List, Upload, Settings, DollarSign, MapPin, Layers, Users, Terminal, LogOut } from "lucide-react";
import { useSimpleAuth } from "@/hooks/useSimpleAuth";
import { Button } from "@/components/ui/button";
import { Separator } from "@/components/ui/separator";
import { useState, useEffect } from "react";
export function AdminSidebar() {
  const navigate = useNavigate();
  const {
    user,
    logout
  } = useSimpleAuth();
  const [loginTime, setLoginTime] = useState<string>('00:00:00');
  const handleLogout = () => {
    logout();
    navigate('/');
  };
  useEffect(() => {
    const startTime = new Date();
    const updateTimer = () => {
      const now = new Date();
      const diff = now.getTime() - startTime.getTime();
      const hours = Math.floor(diff / 3600000);
      const minutes = Math.floor(diff % 3600000 / 60000);
      const seconds = Math.floor(diff % 60000 / 1000);
      setLoginTime(`${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`);
    };
    const timer = setInterval(updateTimer, 1000);
    return () => clearInterval(timer);
  }, []);
  return <aside className="border-r border-border bg-card w-[250px] h-screen overflow-auto fixed left-0 top-0 flex flex-col">
      <div className="p-4 flex-1">
        <Link to="/" className="block mb-6">
          <div className="brand-name">
            <span className="brand-max">Max</span>
            <span className="brand-catalog">Catalog</span>
          </div>
        </Link>

        <nav className="space-y-2">
          {/* Dashboard */}
          <Link to="/admin" className="flex items-center gap-2 p-2 rounded-lg hover:bg-accent">
            <LayoutDashboard size={20} />
            <span>Dashboard</span>
          </Link>

          {/* Produtos */}
          <div className="space-y-1">
            <Link to="/admin/products/list" className="flex items-center gap-2 p-2 rounded-lg hover:bg-accent">
              <Package size={20} />
              <span>Produtos</span>
            </Link>
            <div className="pl-8 space-y-1">
              <Link to="/admin/products/new" className="flex items-center gap-2 p-2 rounded-lg hover:bg-accent text-sm">
                <PlusCircle size={16} />
                <span>Novo Produto</span>
              </Link>
              <Link to="/admin/products/list" className="flex items-center gap-2 p-2 rounded-lg hover:bg-accent text-sm">
                <List size={16} />
                <span>Lista de Produtos</span>
              </Link>
            </div>
          </div>

          {/* Configurações */}
          <div className="space-y-1">
            <div className="flex items-center gap-2 p-2 rounded-lg hover:bg-accent">
              <Settings size={20} />
              <span>Opções</span>
            </div>
            <div className="pl-8 space-y-1">
              <Link to="/admin/settings/price-categories" className="flex items-center gap-2 p-2 rounded-lg hover:bg-accent text-sm">
                <DollarSign size={16} />
                <span>Grupos de Preços</span>
              </Link>
              <Link to="/admin/settings/locations" className="flex items-center gap-2 p-2 rounded-lg hover:bg-accent text-sm">
                <MapPin size={16} />
                <span>Localizações</span>
              </Link>
              <Link to="/admin/settings/material-types" className="flex items-center gap-2 p-2 rounded-lg hover:bg-accent text-sm">
                <Layers size={16} />
                <span>Tipos de Material</span>
              </Link>
            </div>
          </div>

          {/* Sistema */}
          <div className="space-y-1">
            <div className="flex items-center gap-2 p-2 rounded-lg hover:bg-accent">
              <Terminal size={20} />
              <span>Sistema</span>
            </div>
            <div className="pl-8 space-y-1">
              <Link to="/admin/settings/users" className="flex items-center gap-2 p-2 rounded-lg hover:bg-accent text-sm">
                <Users size={16} />
                <span>Usuários</span>
              </Link>
              <Link to="/admin/products/import" className="flex items-center gap-2 p-2 rounded-lg hover:bg-accent text-sm">
                <Upload size={16} />
                <span>Importar Produtos</span>
              </Link>
              <Link to="/admin/settings/system" className="flex items-center gap-2 p-2 rounded-lg hover:bg-accent text-sm">
                <Settings size={16} />
                <span>Configurações</span>
              </Link>
            </div>
          </div>
        </nav>
      </div>

      <div className="border-t p-4 space-y-4">
        <div className="space-y-1">
          <p className="text-sm font-medium">{user?.name || user?.email}</p>
          <p className="text-xs text-muted-foreground">Tempo de login: {loginTime}</p>
        </div>
        <Button variant="outline" size="sm" className="w-full flex items-center gap-2" onClick={handleLogout}>
          <LogOut size={16} />
          Desconectar
        </Button>
        <p className="opacity-70 text-center text-xs text-violet-400">
          code by <a href="https://alisson.ai" target="_blank" rel="noopener noreferrer" className="hover:underline">Alisson Costa</a> | alisson.ai
        </p>
      </div>
    </aside>;
}